//have to be the same as in backend
export const STANDARD = '1';
export const GOOGLE = '2';
export const FACEBOOK = '3';
